import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { baseUrl } from "../../utils/APi";
import { getSlides } from "../../store/slider/SliderAction";
import Loader from "../../component/Loader";
import img1 from "../../assets/4.jpg";
import img2 from "../../assets/5.jpg";
import img3 from "../../assets/3.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from "react-router-dom";

const Banner = () => {
  // const dispatch = useDispatch();
  // const { slider, loading } = useSelector((state) => state.slider);

  // useEffect(() => {
  //   if (slider?.length === 0) {
  //     const promise = dispatch(getSlides());
  //     return () => {
  //       promise.abort();
  //     };
  //   }
  // }, [dispatch, slider?.length]);

  // if (loading !== "idle") return <Loader />;

  return (
    <section className="section-wrap nopadding">
    <div className="container-fluid main-banner">
      <div className="entry-slider">
        <Swiper
          id="flexslider-hero"
          spaceBetween={0}
          slidesPerView={1}
          modules={[Navigation]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
        >
          <SwiperSlide>
            <img src={img1} alt="" />
            <div className="img-holder img-1"></div>
            <div className="hero-holder text-center right-align">
              <div className="hero-lines">
                <h1 className="hero-heading white">Collection 2017</h1>
                <h4 className="hero-subheading white uppercase">HOT AND FRESH TRENDS OF THIS YEAR</h4>
              </div>
              <Link to={"/shop"} className="btn btn-lg btn-white">
                <span>Shop Now</span>
              </Link>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <img src={img2} alt="" />
            <div className="img-holder img-2"></div>
            <div className="hero-holder text-center">
              <div className="hero-lines">
                <h1 className="hero-heading white large">Winter Sales</h1>
              </div>
              <Link to={"/shop"}  className="btn btn-lg btn-white">
                <span>Shop Now</span>
              </Link>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <img src={img3} alt="" />
            <div className="img-holder img-3"></div>
            <div className="hero-holder left-align">
              <div className="hero-lines">
                <h1 className="hero-heading white">Autumn 2017</h1>
                <p className="white">A-ha Theme is the Best E-Commerce solution</p>
                <p className="white">Packed with tons of features and unique styles</p>
              </div>
              <Link to={"/shop"} className="btn btn-lg btn-white">
                <span>Shop Now</span>
              </Link>
            </div>
          </SwiperSlide>

        
        </Swiper>
      </div>
    </div>
  </section>
  );
};
export default Banner;
